import { type Theme } from "@mui/material/styles";

import { type TypographyProps } from "ui/typography/typography";
import { type StatusSize, type StatusType } from "ui/status/status.types";

export const STATUS_INDICATOR_COLOR: Record<StatusType, (theme: Theme) => string> = {
  "not-reviewed-yet": (theme) => theme.palette.grey[400],
  building: (theme) => theme.palette.grey[400],
  "in-review": (theme) => theme.palette.warning.light,
  "feedback-received": (theme) => theme.palette.warning.light,
  approved: (theme) => theme.palette.success.light,
  archived: (theme) => theme.palette.grey[300],
};

type StatusSizeTokens = { indicator: number; padding: number; gap: number };

/**
 * Raw pixels rather than MUI spacing steps: these are consumed inside `styled()`, which gets no
 * `styleFunctionSx` pass, so a half-step would emit `0.5px`.
 */
export const STATUS_SIZE: Record<StatusSize, StatusSizeTokens> = {
  small: { indicator: 10, padding: 1, gap: 4 },
  medium: { indicator: 12, padding: 1, gap: 4 },
  large: { indicator: 14, padding: 0, gap: 6 },
};

/** Figma's label metrics per size, expressed as the theme variants that carry them. */
export const STATUS_LABEL_VARIANT: Record<StatusSize, TypographyProps["variant"]> = {
  small: "caption",
  medium: "body2",
  large: "body1",
};
